import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { constants } from '@atlas/core';
import { Radio } from '@atlas/ui';

import { useOddsFormat } from 'src/components/Pages/Menu/OddsFormatSettings/OddsFormatProvider';

const {
  ODDS_FORMAT: { AMERICAN, DECIMAL, FRACTIONAL, HONGKONG, INDONESIAN, MALAY },
} = constants;

const OddsFormatOptions = [DECIMAL, FRACTIONAL, AMERICAN, HONGKONG, INDONESIAN, MALAY];

const OddsRadio = ({ option }) => {
  const { changeOddsFormat, oddsFormat } = useOddsFormat();

  const onSelectOptionHandler = useCallback(() => {
    if (oddsFormat.toLowerCase() === option.toLowerCase()) return;
    changeOddsFormat(option);
  }, [option, oddsFormat, changeOddsFormat]);

  return (
    <Radio
      active={option.toLowerCase() === oddsFormat.toLowerCase()}
      id={option}
      key={option}
      onClick={() => onSelectOptionHandler(option)}
      text={option}
    />
  );
};

OddsRadio.propTypes = {
  option: PropTypes.string.isRequired,
};

export default function AcceptOddsSettings() {
  return OddsFormatOptions.map(option => <OddsRadio key={option} option={option} />);
}
